import React from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import { useAPI } from "hooks/useAPI"
import ReactApexChart from "react-apexcharts"
import { useIndicadoresFiltrosStore } from "store/useIndicadoresFiltrosStore"

const EntregaUF = props => {
  const REPORT_ID = 5

  const fetchReports = useIndicadoresFiltrosStore(state => state.fetchReports)
  const filtrosSelecionados = useIndicadoresFiltrosStore(
    state => state.filtrosSelecionados
  )

  const { payload, error, isLoading } = useAPI(
    REPORT_ID,
    filtrosSelecionados,
    fetchReports
  )

  const columns = payload?.data?.columns[0]
    .filter((item, idx) => idx > 0)
    .map(item => {
      return item !== null ? item : ""
    })

  const series = payload?.data?.columns
    .filter((item, idx) => idx > 0)
    .map(item => {
      return {
        name: item[0],
        data: item
          .filter((e, i) => i > 0)
          .map(e => {
            return Math.floor(e)
          }),
      }
    })

  const chartOptions = {
    chart: {
      stacked: true,
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: true,
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    xaxis: {
      categories: columns,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return `${val} dias`
        },
      },
      shared: true,
      intersect: false,
    },
  }

  return (
    <Card>
      <CardHeader tag={"h4"} className="bg-transparent border-bottom">
        {!isLoading && payload?.title}
        {isLoading && <span className="placeholder col-3"></span>}
      </CardHeader>
      <CardBody>
        <Row>
          <Col>
            {isLoading && (
              <div className="mt-3" style={{ textAlign: "center" }}>
                <Spinner
                  className="ms-2"
                  style={{ width: "4rem", height: "4rem" }}
                  color="primary"
                />
              </div>
            )}
            {!isLoading &&
              (series?.length > 0 ? (
                <ReactApexChart
                  options={chartOptions}
                  series={series}
                  type="bar"
                  height={600}
                  className="apex-charts"
                ></ReactApexChart>
              ) : (
                <CardTitle className="text-center">
                  Nenhum dado foi encontrado.
                </CardTitle>
              ))}
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

EntregaUF.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(EntregaUF)
